import { Divider, Stack, Typography } from '@mui/material';

import { ColorsRaw } from '@/ui/theme/colors-raw';

const borderRadius = 4;

export function TourCard({
  title,
  headerRightComponent,
  children,
}: {
  title: string;
  headerRightComponent?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <Stack
      sx={{
        border: '1px solid',
        borderColor: ColorsRaw.anthracite.Anthracite_4,
        borderRadius: borderRadius,
      }}
    >
      <Header title={title} rightComponent={headerRightComponent} />
      <Content>{children}</Content>
    </Stack>
  );
}

function Header({
  title,
  rightComponent,
}: {
  title: string;
  rightComponent: React.ReactNode;
}) {
  return (
    <>
      <Stack
        sx={{
          width: '100%',
          flexDirection: 'row',
          justifyContent: 'space-between',
          paddingX: 2,
          paddingY: 2,
          gap: 2,
        }}
      >
        <Typography sx={{ fontSize: '1.5rem', fontWeight: 800 }}>
          {title}
        </Typography>
        {rightComponent}
      </Stack>
      <Divider />
    </>
  );
}

function Content({ children }: { children: React.ReactNode }) {
  return (
    <Stack
      sx={(theme) => ({
        padding: 2,
        gap: 4,
        alignItems: 'center',
        borderBottomLeftRadius: theme.shape.borderRadius * borderRadius,
        borderBottomRightRadius: theme.shape.borderRadius * borderRadius,
        backgroundColor: ColorsRaw.anthracite.Anthracite_2,
      })}
    >
      {children}
    </Stack>
  );
}
